import "./Accordion";

class FaqAccordion {
  constructor() {
    if (document.querySelector(".js-faq-accordion")) {
      new window.Accordion(".js-faq-accordion", {
        duration: 200,
      });
    }
  }
}

export default new FaqAccordion();
